import { render, staticRenderFns } from "./AccountsListPage.vue?vue&type=template&id=63a8909e&scoped=true&"
import script from "./AccountsListPage.vue?vue&type=script&lang=js&"
export * from "./AccountsListPage.vue?vue&type=script&lang=js&"
import style0 from "./AccountsListPage.vue?vue&type=style&index=0&id=63a8909e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8909e",
  null
  
)

export default component.exports